import React, { useState, useEffect } from "react";
import { FaGift, FaCircle, FaSquare } from "react-icons/fa";
import { GiCircle } from "react-icons/gi";
import { connect } from "react-redux";
import { languages } from "../../../helpers/language";

const GiftcardItem = ({ merchantData, customerData }) => {
  const [copyCodeText, setcopyCodeText] = useState("Copy code");
  let { merchant } = merchantData;
  let { currentGiftcard } = customerData;

  let details = {
    balance:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.balance"
      ],
    title_gift:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.title_gift"
      ],
    title_card:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.title_card"
      ],
    copy_code:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.copy_code"
      ],
    copied:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "giftcard.copied"
      ],
    rewards_go_back:
      languages[merchant?.customWidgetTheme?.language || "en"][
        "rewards.go_back"
      ],
  };

  useEffect(() => {
    setcopyCodeText(details.copy_code);
  }, [merchant]);

  return (
    <div className="giftcard-container">
      <div className="giftcard-text">
        <h1>
          {merchant?.currentPlan?.planName !== "free" &&
          merchant?.customWidgetTheme?.textCustomization
            ? merchant?.customWidgetTheme?.textCustomization?.giftcard
            : `${details.title_gift} ${details.title_card}`}
        </h1>
      </div>
      <div>
        <p
          style={{
            fontSize: "13px",
            margin: "10px 0",
          }}
        >
          {details.balance} {currentGiftcard?.text}
        </p>
      </div>

      <FaCircle className="faCirle-1" />

      <FaCircle className="faCirle-2" />

      <GiCircle className="giCirle-1" />

      <FaCircle className="faCirle-3" />

      <FaCircle className="faCirle-4" />

      <FaCircle className="faCirle-5" />

      {/* Apply Code btn */}
      <div className="giftcard-copy-button-container">
        <button
          onClick={() => {
            navigator.clipboard.writeText(currentGiftcard?.code);
            setcopyCodeText(details.copied);
          }}
          className="giftcard-copy-button"
        >
          {copyCodeText}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  merchantData: state.MerchantReducer,
  customerData: state.CustomerReducer,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GiftcardItem);
